import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'counter']

  static values = {
    maxLength: {
      type: Number,
      default: 175
    }
  }

  connect () {
    this.updateCounter()
  }

  updateCounter () {
    const length = this.fieldTarget.value.length
    this.counterTarget.textContent = `${length}/${this.maxLengthValue} `
  }
}
